"use client";
import Toast from "@/components/Toast";
import ShareIOSDark from "@/public/shareiOS-white_outlined.svg";
import ShareIOSLight from "@/public/shareiOS_outlined.svg";
import { useAppStore } from "@/store/app";
import { APP_NAME, UA, getLocationOrigin } from "@/utils/constants";
import Image from "next/image";
import { HiShare } from "react-icons/hi";
import shallow from "zustand/shallow";

const LOG_TAG = "ShareApp";
const modalId = "share-app-modal";

export default function ShareApp({
  useButtonText,
  url,
}: {
  useButtonText?: string;
  url?: string;
}) {
  const { theme, user } = useAppStore(
    ({ theme, user }) => ({ theme, user }),
    shallow,
  );
  let canWebShare = false;
  if (typeof window !== "undefined") {
    canWebShare = !!window.navigator.share;
  }

  if (!url) {
    if (user) {
      url = `${getLocationOrigin()}/add-friend/${user.id}`;
    } else {
      url = getLocationOrigin();
    }
  }
  //console.debug(LOG_TAG, "ShareApp", { canWebShare, url });

  const onClickShare = () => {
    console.debug(LOG_TAG, "onClickShare", { canWebShare });
    window.analyticsLogEvent("Clicked Share", { url });
    if (!canWebShare) {
      window.navigator.clipboard.writeText(url);
      return;
    }
    window.navigator
      .share({
        title: `Check out my songs in ${APP_NAME}`,
        text: `I've shared my chords and lyrics here: `,
        url,
      })
      .then(() => console.log("Successful share"))
      .catch((error) => console.log("Error sharing", error));
  };

  if (useButtonText) {
    return (
      <button
        className="btn btn-primary rounded"
        onClick={onClickShare}
        type="button"
      >
        {useButtonText}
      </button>
    );
  }
  const shareIconIOS = (
    <Image
      src={theme === "dark" ? ShareIOSDark : ShareIOSLight}
      width={24}
      height={24}
      alt="share"
    />
  );

  return (
    <div>
      <label
        onClick={onClickShare}
        htmlFor={modalId}
        className="text-primary-content flex items-center text-2xl cursor-pointer"
      >
        {UA.isIOS() ? shareIconIOS : <HiShare />}
      </label>
      <Toast id={modalId}>Copied link to clipboard!</Toast>
    </div>
  );
}
